import React from "react";
import styled from "styled-components";
import { ThemedText } from "@components/ThemedText";

const PausedCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.ui.background.error};
`;

export const IfIsaPausedCard = () => {
  return (
    <PausedCard>
      <ThemedText type="S16" color="SLATE900">
        Your IF-ISA account is on pause
      </ThemedText>
      <ThemedText type="P14" color="SLATE800">
        Since you’ve changed your residency status, your IF-ISA is now on pause.
        If you think this is a mistake, please contact our team through our
        in-app chat.
      </ThemedText>
    </PausedCard>
  );
};
